import logo from './logo.svg';
import{ useState,useEffect } from 'react';
import './App.css';
import { Hero } from './Components/Hero';
import { About } from './Components/About';
import { Footer } from './Components/Footer';
import { Copyrights } from './Components/Copyrights';
import WhyUs from './Components/WhyUs';
import Features from './Components/Features';
import Map from './Components/Map';
import { MapInfo }  from "./Components/MapInfo";
import Gallery from './Components/Gallery';
import Resort from './Components/Resort';
import PopupContactForm from './Components/PopupContactForm';
import Roi from './Components/Roi';
import Sustainablitiy from './Components/Sustainablitiy';
import {Contact} from './Components/Contact';
import { IconsPlacer } from './Components/IconsPlacer';
import { firePageView } from './Components/ConversionHandler';
import Sponcer from './Components/Sponcer';


function App() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    firePageView();
  }, []);

  return (
    <div className="App">
      <Hero onContactClick={() => setShowPopup(true)} />
        <IconsPlacer/>
      <PopupContactForm showPopup={showPopup} setShowPopup={setShowPopup} />
      <Features onKnowMoreClick={() => setShowPopup(true)}/>
      <Roi/>
      <Map/>
      <MapInfo onContactClick={() => setShowPopup(true)}/>
      <WhyUs/>
      <Resort/>
      <Sustainablitiy onKnowMoreClick={() => setShowPopup(true)}/>
      <Gallery/>
      <About/>
      <Sponcer/>
      <Contact/>
      <Footer/>
      <Copyrights/>
    </div>
  );
}

export default App;
